<route>
{
  "meta": {
    "permission": [
      "packages.view_payment"
    ]
  }
}
</route>

<template>
  <div class="px-2">
    <dial-payment v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <i-table
      api="company.payment"
      dontCreate
      dontRemove
      :headers="headers"
      :otherPermission="isAdmin"
      :reload.sync="reload"
      :title="$tc('payment', 2)"
      @click:edit="isAdmin ? open($event) : ''"
    >
      <template v-slot:item.approved="{ item }">
        <p class="mb-0 text-center">
          <v-icon :color="item.approved ? 'secondary' : 'red'">
            {{ item.approved ? 'fa-check' : 'fa-times' }}
          </v-icon>
        </p>
      </template>
      <template v-slot:item.amount="{ value }">
        <i-money :value="value" mode="text" />
      </template>
    </i-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DialPayment from '@/components/subDomain/payment.vue'
export default {
  components: {
    DialPayment
  },
  data() {
    return {
      dialog: false,
      toEdit: null,
      reload: false
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'session/isAdmin'
    }),
    headers() {
      return [
        {
          text: this.$t('payment_number'),
          value: 'payment_number'
        },
        {
          text: this.$t('state'),
          value: 'state'
        },
        {
          text: this.$tc('amount', 1),
          value: 'amount',
          align: 'right'
        },
        {
          text: this.$t('payment_type'),
          value: 'payment_type'
        },
        {
          text: this.$t('date_pay'),
          value: 'date_pay'
        },
        {
          text: this.$tc('user', 1),
          value: 'user.username'
        },
        {
          text: this.$tc('package', 1),
          value: 'package.name'
        },
        {
          text: this.$t('approved'),
          align: 'center',
          value: 'approved'
        },
        {
          text: this.isAdmin ? this.$t('action') : '',
          align: 'center',
          width: '160px',
          value: this.isAdmin ? 'actions' : ''
        }
      ]
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
